/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

'use strict';

angular.module('prism-ui.components').service('TransformTemplatesService',
    function (this: JS5Object, _: JS5Object, TransformTemplatesResourceFactory: JS5Object,
              PaginationService: JS5Object) {

        this.originalEditData = {};
        const handleGridDataQuery = (gridData, responseHeaders) => {
            PaginationService.parseResponseHeaders(responseHeaders());
            PaginationService.pageData = gridData;
            this.currentPageSize = gridData.length;
        };

        this.getAllTransformTemplates = (queryParams: JS5Object) => {
            return TransformTemplatesResourceFactory.query(queryParams, handleGridDataQuery).$promise;
        };
        this.getTransformTemplate = (transformTemplateId: number) => {
            return TransformTemplatesResourceFactory.get({id: transformTemplateId}).$promise;
        };
        this.createTransformTemplate = (transformTemplate: JS5Object) => {
            return TransformTemplatesResourceFactory.save(transformTemplate).$promise;
        };
        this.cloneTransformTemplate = (transformTemplate: JS5Object) => {
            return TransformTemplatesResourceFactory.clone({id: transformTemplate.id}).$promise;
        };
        this.updateTransformTemplate = (transformTemplate: JS5Object) => {
            return TransformTemplatesResourceFactory.update(transformTemplate).$promise;
        };
        this.toggleTransformTemplateHidden = (transformTemplateId: number) => {
            return TransformTemplatesResourceFactory.toggleArchive({id: transformTemplateId}).$promise;
        };
    });
